/**
 * Repeat prescription form
 */

const addItemButton = (fieldId) => {
  const button = Object.assign(document.createElement("a"), {
    className: "nhsuk-button nhsuk-button--secondary",
    innerHTML: "Add another item",
    onclick: () => {
      document.getElementById(fieldId).style.display = "block";
      button.style.display = "none";
    },
  });
  button.setAttribute("style", "text-decoration:none;");
  return button;
};

// Hide entry and reset field values
const removeItemButton = (fieldId) => {
  return;
  const button = Object.assign(document.createElement("a"), {
    className: "nhsuk-button nhsuk-button--reverse nhsuk-u-margin-left-3",
    innerHTML: "Remove item",
    onclick: () => {
      document.getElementById(fieldId).style.display = "none";
      button.style.display = "none";
    },
  });
  button.setAttribute("style", "text-decoration:none;");
  return button;
};

const repeatPrescriptionForm = (el) => {
  const fields = el.getElementsByClassName("frm_form_field sr_only_label");
  // Abort if supported fields not found
  if (!fields) {
    return;
  }
  const maxItems = fields.length / 3;
  const experimental = el.classList.contains("exp") ? true : false;
  let itemRow = 1;

  el.classList.add("nhsuk-u-padding-top-3");
  el.querySelectorAll(".medtitle").forEach((e) => e.remove());

  for (let i = 0; i < fields.length; i++) {
    const fieldId = `${el.id}-${itemRow}`;
    if ((i + 1) % 3 === 0) {
      // Third field
      document.getElementById(fieldId).prepend(
        Object.assign(document.createElement("legend"), {
          className: "nhsuk-fieldset__legend nhsuk-fieldset__legend--s",
          innerHTML: `Item ${itemRow} of ${maxItems}`,
        })
      );

      fields[i].querySelector("input").classList.add("nhsuk-input--width-5");
      document.getElementById(fieldId).appendChild(fields[i]);
      // Hide aditional items
      if (experimental && itemRow > 1) {
        document.getElementById(fieldId).style.display = "none";
      }
      itemRow++;
      // Add button
      if (experimental && itemRow <= maxItems) {
        const field = document.getElementById(fieldId);
        field.append(addItemButton(`${el.id}-${itemRow}`));
        if (itemRow > 2) {
          //field.append(removeItemButton(fieldId));
        }
      }
    } else if ((i + 2) % 3 === 0) {
      // Second field
      fields[i].querySelector("input").classList.add("nhsuk-u-width-one-half");

      document.getElementById(fieldId).appendChild(fields[i]);
    } else {
      // First field
      fields[i]
        .querySelector("input")
        .classList.add("nhsuk-u-width-three-quarters");
      fields[i].before(
        Object.assign(document.createElement("fieldset"), {
          className: "nhsuk-fieldset nhsuk-u-padding-bottom-5",
          id: fieldId,
        })
      );
      document.getElementById(fieldId).appendChild(fields[i]);
    }
  }
};

export default repeatPrescriptionForm;
